export default {
      id: "circle__pin-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__pin",
      toString: function () {
        return this.url;
      }
    }